<template>
  <div class="login-container">
    <el-card class="login-card" shadow="hover">
      <h2 class="login-title">{{$t('login')}}</h2>
        <el-form label-position="left" ref="loginForm" :model="loginForm">

          <el-form-item :label="$t('username')">
            <el-input v-model="loginForm.phone" type="text" placeholder="Нэтрэх нэрээ оруулна уу" />
          </el-form-item>

          <el-form-item :label="$t('password')">
          <el-input v-model="loginForm.password" type="password"
            placeholder="Нууц үгээ оруулна уу"
          />
          </el-form-item>

        </el-form>
      <el-button class="signup_button w-100" type="primary" @click="handleLogin('loginForm')">{{$t('login')}}</el-button><br/>
      <el-button class="register_button w-100" type="text" @click="goToRegister()">{{$t('register')}}</el-button>
      <el-button class="register_button forget_password_color" type="text" @click="goToHome()">{{$t('forgetpassword')}}</el-button>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loginForm: {
        phone: '',
        password: ''
      }
    }
  },
  methods: {
    handleLogin (formName) {
      this.$root.fullscreenLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch('signin', this.loginForm).then(response => {
            if (response.success.token) {
              this.$store.dispatch('authUserLoginPage', response)
              this.$store.dispatch('userAdd', response.user)
              this.$store.dispatch('companyAdd', response.company)
              // this.padd()
              // window.location.href = '/'
              this.$root.fullscreenLoading = false
              this.$router.push({
                name: 'Profile'
              })
            }
            this.$root.fullscreenLoading = false
          }, error => {
            console.log(error)
            this.$root.fullscreenLoading = false
          })
        } else {
          console.log('Error during validation')
          return false
        }
      })
    },
    goToRegister () {
      this.$router.push({ path: '/register' })
    },
    goToHome () {
      this.$router.push({ path: '/' })
    }
  }
}
</script>

<style scoped>
  .login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70vh;
    background-color: #f5f5f5;
  }

  .login-card {
    width: 400px;
    padding: 30px;
  }

  .login-title {
    text-align: center;
    margin-bottom: 20px;
  }

  .forget_password_color{
    color: #5E1EE5;
  }
</style>
